import Swal from "sweetalert2";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { errorManager } from "../../../presentation/utils/errorManager";

export const sendEmailHelp = (tmpData) => async (dispatch) => {
  const {puntoVenta, uid } = tmpData;
  try {
    const params = new URLSearchParams({
      pointOfSale: puntoVenta,
      ...(uid && { user: uid }) 
    });
    const response = await fetch(`${RemoteConstants.BASE_URL}pos/send/email/help?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.code === 'OK') {
      Swal.fire(data.userMessage, 'Hemos enviado un correo de asistencia a la dirección de tu administrador', 'success');
    } else {
      errorManager(data.userMessage);
    }
  } catch (error) {
    errorManager(error)
  }
  dispatch(UIActions.uiLoadInactive());
}